import { render, staticRenderFns } from "./MentorshipDuration.vue?vue&type=template&id=440f81ee&scoped=true&"
import script from "./MentorshipDuration.vue?vue&type=script&lang=js&"
export * from "./MentorshipDuration.vue?vue&type=script&lang=js&"
import style0 from "./MentorshipDuration.vue?vue&type=style&index=0&id=440f81ee&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "440f81ee",
  null
  
)

export default component.exports